import React from 'react';

const KCSummaryPhase = ({score, termName, onContinue, continueDisabled = false}) => {
  return (
    <div className="lcv-kc-summary">
      <div className="lcv-kc-score">{score.correct}/{score.total}</div>
      <div className="lcv-kc-label">Knowledge Check Complete!</div>
      <p style={{color: 'rgba(255,255,255,0.6)', marginTop: 8, fontSize: 15}}>
        You completed the knowledge check for <strong style={{color: '#C6FF00'}}>{termName}</strong>
      </p>
      <button
        className="lcv-btn-primary lcv-btn-full"
        style={{marginTop: 20}}
        onClick={onContinue}
        disabled={continueDisabled}>
        Continue →
      </button>
    </div>
  );
};

export default KCSummaryPhase;
